import statesMixin from './statesMixin';
import { mapState } from 'vuex';

export default {
  mixins: [statesMixin],
  computed: {
    ...mapState('models/projection', ['states']),
  },
};
